<template>
  <div class="col-sm-6 col-lg-4 col-xl-3" :class="{'col-6': arrangeTwoColsForMobile}">

    <div class="collage-photo-item" :data-photo-id="photo.id"
         :class="{'cursor-pointer': !isUnlocked }">
      <div class="collage-photo-item__image-container" @click="$emit('zoom-clicked', photo)">
        <img v-lazy="photo.image_url"
             class="collage-photo-item__image">
      </div>
      <ul class="nav collage-photo-item__actions">
        <li class="nav-item ">
          <ButtonToggleCart :loading="loading" :action="actionCart" @click="toggleSelection()"/>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import ButtonToggleCart from "@/components/ButtonToggleCart";
import {ADD_TO_CART, REMOVE_TO_CART} from "@/components/interface/svg/IconCart";
import {observeMedia} from "@/utils/media";

export default {
  components: {
    ButtonToggleCart
  },
  props: {
    photo: Object,
    index: {
      type: Number,
      default: null
    },

    arrangeTwoColsForMobile: {
      type: Boolean,
      default: true,
      required: false
    },

    digitalItemId: {
      type: Number,
      default: null
    },

    picacode: {
      type: String,
      default: null
    },

    initiallySelected: {
      type: Boolean,
      default: false
    },

    isUnlocked: {
      type: Boolean,
      default: false
    },

    hasPhotoOriginal: {
      type: Boolean,
      default: false
    },

    dtPhotosHdAvailable: {
      type: String,
      default: ''
    },

    enableZoom: {
      type: Boolean,
      default: true
    },

    useSelectLabel: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // imageLoaded: false,
      loading: false,
      addedToCart: false,
    }
  },

  mounted() {
    this.addedToCart = !!this.$store.getters['cart/isDigitalPhotoInCart'](this.picacode, this.photo.id)
    this.observeMedia(this.$el, '.collage-photo-item', this.photo.id)
  },

  computed: {
    isPortrait() {
      return this.photo.original_height > this.photo.original_width
    },
    actionCart() {
      return this.addedToCart ? REMOVE_TO_CART : ADD_TO_CART
    }
  },

  methods: {
    observeMedia,

    /** PAY ATTENTION **/
    //MOVED TO ModalPhotoGallery.vue
    toggleSelection() {
      this.addedToCart ? this.removeFromCart() : this.addToCart()
    },

    handlePhotoClicked() {
      if (this.enableZoom) {
        this.$emit('zoom-clicked', this.photo.id)
      }
    },

    addToCart() {
      this.loading = true
      let photoIds = [this.photo.id]
      if (this.digitalItemId) {
        this.$store.dispatch('cart/addPhotosToDigitalItem', {
          digitalItemId: this.digitalItemId,
          photoIds: photoIds,
        })
            .then(() => {
              this.addedToCart = true
              this.loading = false
              this.$emit('photo-cart-added')
            })
      } else {
        this.$store.dispatch('cart/addDigitalItemToCart', {
          picacode: this.picacode,
          photoIds: photoIds,
        })
            .then(response => {
              this.addedToCart = true
              console.log(response.data)
              // notify the creation of a digital item, parent component will have to set the digitalItemId
              this.$emit('digital-item-updated')
              this.$emit('photo-cart-added')
            })
            .catch(error => {
              console.log(error)
              if (error.response.status === 400 && error.response.data.code === 'cart_currency_mismatch') {
                this.$bvModal.show('modal-currency-mismatch')
              }
              if (error.response.status === 400 && error.response.data.code === 'purchase_disabled') {
                this.$bvToast.toast(error.response.data.detail, {
                  title: this.$t('collage_photo_item.purchase_not_available'),
                  headerClass: 'd-block pt-2',
                  autoHideDelay: 5000,
                  toaster: 'b-toaster-top-center'
                })
              }
            })
            .finally(() => {
              this.loading = false
            })
      }
    },

    removeFromCart() {
      this.loading = true
      const photoIds = [this.photo.id]

      this.$store.dispatch('cart/deletePhotosFromDigitalItem', {
        digitalItemId: this.digitalItemId,
        photoIds: photoIds,
      }).then(() => {
        this.addedToCart = false
        this.loading = false
        this.$emit('digital-item-updated')
      })

    }
  }
}
</script>
